module.exports = __webpack_public_path__ + "img/ecological-construction.8f80f48e.png";